import TokenNamePrice from './TokenNamePrice';

export default TokenNamePrice;
